import React , {Component}                          from 'react';
import { Container }                                from 'react-grid-system';
import {  Button, Select}                           from 'antd';

import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import {  message } from "antd";

import './style.scss';

import KeyList          from './KeyList/KeyList';
import tickIcon         from '../../../assets/img/tick.png';
import BackDrop         from '../../../components/UI/Backdrop/Backdrop';
import { refresh_profile } from "../../../actions/auth";
import CloudFlyerAPI from "../../../api/CloudFlyerAPI";
import { fetchApiKey } from "../../../actions/api-key";


class SecurityCredentials extends Component {

    constructor(props) {
        super();
        const { user } = props;
    
        this.state={
        apiKey:[],
        user:{},
        popUp:false,
        popUpIcon:tickIcon,
        IAMkeys:{
            accessKeyID:"",
            secretAccessKey:""
            }
        }

    }    

    componentDidMount() {
        this.props.refresh_profile(true);
    
    }

    componentWillReceiveProps({ user }) {

          this.setState({
            user
          });

    }    
    

    createAccessKeyHandler = () =>{

        CloudFlyerAPI.user_account
          .createApi()
          .then((data) => {
            this.setState({ IAMkeys: {
                accessKeyID  : data.data.access_key,
                secretAccessKey : data.data.secret_key
            },
            popUp:true });

            this.props.fetchApiKey()

          })
          .catch(this.handleError);
        

        
    }

    closeAccessKeyPopUpHandler= () =>{
        this.setState({popUp:false})
    }
    
    render(){

        // POP UPS
        const popUpComponent = this.state.popUp ? 
        <div>
            <BackDrop show={this.state.popUp} close={this.closePopUpHandler}/>

            <div className="accessKeyPopUp">
                <div className="icon">
                    <img src={this.state.popUpIcon} alt="success-tick-icon"/>
                </div>
                <header>
                    <h2>Success</h2>
                </header>
                <article>
                    <p> This is the only time the Secret access keys will be available. Please save them somewhere safe.<br/> You cannot recover them later. However you can create new access keys at anytime.</p>
                </article>

                <div className="popUpTable">
                    <dir className="popUpTableHeader">
                        <ul>
                            <li>Access Key ID</li>
                            <li>Secret Access Key</li>
                        </ul>
                    </dir>
                    <dir className="popUpTableContent">
                        <ul>
                            <li>{this.state.IAMkeys.accessKeyID}</li>
                            <li>{this.state.IAMkeys.secretAccessKey}</li>
                        </ul>
                    </dir>

                </div>
                
                <footer>
                    <Button className="button" onClick={this.closeAccessKeyPopUpHandler}>OK</Button>
                </footer>
            </div> 

            
        </div>:null;

        return (
            <div>
                <div className="accessKeys">
                    <div className="pageTitle">
                        <h1>Access Keys</h1>
                    </div>
                </div>
                
                <Container className="Wrapper">
                    <div className="content">
                        <h4>
                            Use access keys to make secure REST or HTTP Query protocol requests to AWS service APIs.<br /> You should never share your keys with anyone. As a best practice, we recommend frequent key rotation.
                        </h4>
                    </div>

                    
                    <Button className="createKey" onClick={this.createAccessKeyHandler}>
                        Create Access Key
                    </Button>

                    <div className="borderBottom"></div>
                    <KeyList/>
                </Container >

                {popUpComponent}

            </div>
        )
    }
    
}

// / export default SecurityCredentials;
function mapStateToProps({  auth: { user } = {} }) {
    return {  user };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      fetchApiKey: bindActionCreators(fetchApiKey, dispatch),
      refresh_profile
    };
  }
  
  export default withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SecurityCredentials)
  );
  


